import { TemplateElement, html, defineElement } from '@webtides/element-js';
import style from './modal-element.css';
import ModalElementEvent from './ModalElementEvent';

export default class ModalElement extends TemplateElement {
    #identifier = null;
    #currentlyActiveModal = null;

    constructor() {
        super({ shadowRender: true, autoUpdate: true, styles: [style] });
    }

    properties() {
        return {
            disableFooter: false,
            openState: false,
            modalId: false,
            modalDialogWidth: '',
            hasTitleSlot: true,
        };
    }
    connected() {
        this.#identifier = this.modalId || Math.random().toString(36).substr(2, 5);
    }

    events() {
        return {
            window: {
                [ModalElementEvent.OPEN]: (ev) => {
                    if (ev.target !== this) {
                        this.#currentlyActiveModal = ev.target;
                    }
                },
                [ModalElementEvent.CLOSE]: (ev) => {
                    if (this.#currentlyActiveModal === ev.target) {
                        this.#currentlyActiveModal = null;
                    }
                },
            },
        };
    }

    addEventListeners() {
        this.getRoot().addEventListener('click', this.onClick.bind(this));
        document.addEventListener('keydown', this.onKeyDown.bind(this));
    }

    removeEventListeners() {
        this.getRoot().removeEventListener('click', this.onClick);
        document.removeEventListener('keydown', this.onKeyDown);
    }

    onClick(event) {
        if (event.target.hasAttribute('data-modal-close')) {
            this.close();
            event.preventDefault();
        }
    }

    onKeyDown(e) {
        if (e.key === 'Escape') this.close();
    }

    open() {
        this.setAttribute('cloak', 'false');
        this.$refs.modal.setAttribute('aria-hidden', 'false');
        this.$refs.modal.classList.add('is-open');
        this.openState = true;
        this.dispatch(ModalElementEvent.OPEN, null, true);
        this.addEventListeners();
    }

    close() {
        this.$refs.modal.setAttribute('aria-hidden', 'true');
        this.$refs.modal.classList.remove('is-open');
        this.openState = false;
        this.dispatch(ModalElementEvent.CLOSE, null, true);
        this.removeEventListeners();
    }

    get currentlyActiveModal() {
        return this.#currentlyActiveModal;
    }

    template() {
        return html`
            <div id="modal-${this.#identifier}" ref="modal" class="modal" aria-hidden="true">
                <div class="modal-overlay" tabindex="-1">
                    <div class="modal-backdrop" data-modal-close></div>
                    <div class="modal-dialog ${this.modalDialogWidth}">
                        <header part="header" ref="header" class="pb-2 font-bold">
                            <div
                                class="${this.hasTitleSlot
                                    ? 'justify-between'
                                    : 'justify-end'} flex items-center text-2.5xl">
                                <slot name="title"></slot>
                                <div class="flex text-grey-900" data-modal-close>
                                    <slot name="close"></slot>
                                </div>
                            </div>
                        </header>
                        <main>
                            <slot name="content"></slot>
                        </main>
                        ${this.disableFooter === true
                            ? ''
                            : html`
                                  <footer ref="footer" class="p-4">
                                      <slot name="footer"></slot>
                                  </footer>
                              `}
                    </div>
                </div>
            </div>
        `;
    }
}

export function define() {
    defineElement('modal-element', ModalElement);
}
